import React from 'react'
import { useReportItem } from '../../Hook/App'
import Layout from '../../Layout'
import HeaderMain from '../../Components/HeaderMain'
function Index() {
    const { setForm, send, items, form, user } = useReportItem();

    const Item = ({ item }) => {
        return (
            <div className="item">
                <input checked={form['for[' + item.key + ']'] ? true : false} onChange={() => { setForm('for[' + item.key + ']', form['for[' + item.key + ']'] ? false : item.title) }} type="checkbox" />
                <span>{item.title}</span>
            </div>
        );
    }

    return (
        <Layout>
            <HeaderMain lable="گزارش آگهی" />
            <div className="report-main">
                <div className="center">دلایل گزارش این آگهی را انتخاب کنید</div>
                {items.map((item, i) => <Item key={i} item={item} />)}

                <div className='mt-4'>
                    {
                        !user ?
                            <>
                                <span>ایمیل شما</span>
                                <input onChange={({ target }) => { setForm('email', target.value) }} className="input" type="email" />
                                <span>موبایل شما</span>
                                <input onChange={({ target }) => { setForm('mobile', target.value) }} className="input" type="number" />
                            </>
                            : null
                    }
                    <span>پیام</span>
                    <textarea onChange={({ target }) => { setForm('message', target.value) }} name="" id="" cols="30" rows="4"></textarea>
                    <button onClick={send} className="btn">ارسال</button>
                </div>

            </div>
        </Layout>
    )
}

export default Index